export default __webpack_public_path__ + "static/media/back-ten_1.ef637a7b.png";